import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Environment } from '../environment/environment';
import { explodeObjectIntoQueryParams } from '../utils/explode-object-into-query-params';
import { removeNullValuesFromObject } from '../utils/remove-null-values-from-object';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  keepalive?: boolean;
}

export const applicationHttpClientCreator = (): ApplicationHttpClient => new ApplicationHttpClient();

@Injectable()
export class ApplicationHttpClient {
  public readonly http = inject(HttpClient);
  private readonly environment = inject(Environment);

  get<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
    let params;
    if (options?.params) {
      params = removeNullValuesFromObject(explodeObjectIntoQueryParams(options.params));
    }
    return this.http.get<T>(`${this.environment.urls.apiUrl}${endPoint}`, {
      ...options,
      ...{ params: params ? params : null },
    });
  }

  post<T>(endPoint: string, body: object | undefined, options?: IRequestOptions): Observable<T> {
    return this.http.post<T>(`${this.environment.urls.apiUrl}${endPoint}`, body, options);
  }

  put<T>(endPoint: string, body: object | undefined, options?: IRequestOptions): Observable<T> {
    return this.http.put<T>(`${this.environment.urls.apiUrl}${endPoint}`, body, options);
  }

  delete<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
    return this.http.delete<T>(`${this.environment.urls.apiUrl}${endPoint}`, options);
  }

  patch<T>(endPoint: string, body: object | undefined, options?: IRequestOptions): Observable<T> {
    return this.http.patch<T>(`${this.environment.urls.apiUrl}${endPoint}`, body, options);
  }
}
